import React from "react";
import "./VisaOffers.css";

const VisaOffers = () => {
  const visaOffers = [
    {
      id: 1,
      country: "Dubai Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_United_Arab_Emirates.svg/1280px-Flag_of_the_United_Arab_Emirates.svg.png",
      offer: "14 DAYS VISA",
      description: "Express processing with 99% approval rate",
      processing: "24-48 Hours",
      rating: "4.8/5",
      popular: true,

      type: "Tourist",
    },
    {
      id: 2,
      country: "Thailand Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/1280px-Flag_of_Thailand.svg.png",
      offer: "30 DAYS VISA",
      description: "Single entry tourist visa",
      processing: "3-5 Days",
      rating: "4.7/5",
      popular: true,

      type: "Tourist",
    },
    {
      id: 3,
      country: "Singapore Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Singapore.svg/1280px-Flag_of_Singapore.svg.png",
      offer: "MULTIPLE ENTRY",
      description: "30 days validity with multiple entries",
      processing: "3-4 Days",
      rating: "4.6/5",
      popular: false,

      type: "Tourist",
    },
    {
      id: 4,
      country: "Malaysia Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Malaysia.svg/1280px-Flag_of_Malaysia.svg.png",
      offer: "E-VISA AVAILABLE",
      description: "Electronic visa with quick processing",
      processing: "2-3 Days",
      rating: "4.5/5",
      popular: true,

      type: "Tourist",
    },
    {
      id: 5,
      country: "UK Visa",
      logo: "https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/1280px-Flag_of_the_United_Kingdom.svg.png",
      offer: "6 MONTHS VISA",
      description: "Standard visitor visa",
      processing: "15-20 Days",
      rating: "4.4/5",
      popular: true,

      type: "Tourist",
    },
    {
      id: 6,
      country: "USA Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/1280px-Flag_of_the_United_States.svg.png",
      offer: "B1/B2 VISA",
      description: "Business & tourist visa",
      processing: "Interview Based",
      rating: "4.3/5",
      popular: false,

      type: "Business/Tourist",
    },
    {
      id: 7,
      country: "Australia Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/1280px-Flag_of_Australia_%28converted%29.svg.png",
      offer: "VISITOR VISA",
      description: "Up to 12 months stay",
      processing: "20-25 Days",
      rating: "4.5/5",
      popular: true,

      type: "Tourist",
    },
    {
      id: 8,
      country: "Schengen Visa",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Flag_of_Europe.svg/1280px-Flag_of_Europe.svg.png",
      offer: "26 COUNTRIES",
      description: "Multiple countries access",
      processing: "10-15 Days",
      rating: "4.6/5",
      popular: true,

      type: "Tourist",
    },
  ];

  // Fallback SVG for broken images
  const getFallbackSvg = (countryName) => {
    return `data:image/svg+xml;base64,${btoa(`
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="12" fill="#F3F4F5"/>
        <text x="30" y="35" text-anchor="middle" fill="#676A7D" font-family="Arial, sans-serif" font-size="12">${
          countryName.split(" ")[0]
        }</text>
      </svg>
    `)}`;
  };

  const handleImageError = (e, countryName) => {
    e.target.src = getFallbackSvg(countryName);
  };

  return (
    <div className="VisaOffers">
      <div className="VisaOffers-section-header">
        <h2>🛂 Popular Visa Services</h2>
        <p>Fast and reliable visa processing</p>
      </div>

      <div className="VisaOffers-scroll-container">
        <div className="VisaOffers-scroll">
          {visaOffers.concat(visaOffers).map((offer, index) => (
            <div key={`${offer.id}-${index}`} className="VisaOffers-card">
              {offer.popular && (
                <div className="VisaOffers-popular-badge">Most Popular</div>
              )}

              <div className="VisaOffers-card-header">
                <img
                  src={offer.logo}
                  alt={offer.country}
                  className="VisaOffers-logo"
                  onError={(e) => handleImageError(e, offer.country)}
                />
                <div className="VisaOffers-country-info">
                  <h3>{offer.country}</h3>
                  <div className="VisaOffers-rating">
                    <span className="VisaOffers-stars">★★★★★</span>
                    <span className="VisaOffers-rating-text">
                      {offer.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="VisaOffers-card-body">
                <div className="VisaOffers-offer-main">
                  <h4>{offer.offer}</h4>
                  <p>{offer.description}</p>
                  <div className="VisaOffers-details">
                    <div className="VisaOffers-processing">
                      ⏱️ {offer.processing}
                    </div>
                  </div>
                  <div className="VisaOffers-type">
                    <span className="VisaOffers-type-badge">{offer.type}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VisaOffers;
